//import axios from 'axios';

import axios from "axios";
import {getMessagesData} from '../../api/modules/messages.api'


const state={
    messages:[
      {
        id: "1", 
        age: 21,
        name: "Shad Jast1",
        email: "pfeffer.matt@yahoo.com",
      },
        {
        id: "2",
        age: 21,
        name: "Shad Jast2",
        email: "pfeffer.matt@yahoo.com",
      },
        {
        id: "3",
        age: 21,
        name: "Shad Jast3",
        email: "pfeffer.matt@yahoo.com",
      },
        {
        id: "4",
        age: 21,
        name: "Shad Jast4",
        email: "pfeffer.matt@yahoo.com",
      },
       {
        id: "5",
        age: 21,
        name: "Shad Jast5",
        email: "pfeffer.matt@yahoo.com",
      },
       {
        id: "6",
        age: 21,
        name: "Shad Jast6",
        email: "pfeffer.matt@yahoo.com",
      },
       {
        id: "7",
        age: 21,
        name: "Shad Jast7",
        email: "pfeffer.matt@yahoo.com",
      },
       {
        id: "8",
        age: 21,
        name: "Shad Jast8",
        email: "pfeffer.matt@yahoo.com",
      },
       {
        id: "9",
        age: 21,
        name: "Shad Jast9",
        email: "pfeffer.matt@yahoo.com",
      },
       {
        id: "10",
        age: 21,
        name: "Shad Jast10",
        email: "pfeffer.matt@yahoo.com",
      },
       {
        id: "11",
        age: 21,
        name: "Shad Jast11",
        email: "pfeffer.matt@yahoo.com",
      },
       {
        id: "12",
        age: 21,
        name: "Shad Jast12",
        email: "pfeffer.matt@yahoo.com",
      },
       {
        id: "13",
        age: 21,
        name: "Shad Jast13",
        email: "pfeffer.matt@yahoo.com",
      },
      {
        id: "14",
        age: 45,
        name: "Duane Metz14",
        email: "mohammad.ferry@yahoo.com",
      },
      { id: "3", age: 34, name: "Myah Kris", email: "evolkman@hotmail.com" },
      {
        id: "15",
        age: 19,
        name: "Dr. Kamron Wunsch15",
        email: "lenora95@leannon.com",
      },
      {
        id: "16",
        age: 29,
        name: "David Pella16",
        email: "lenora95@leannon.com",
      },
      {
        id: "17",
        age: 27,
        name: "Richard Jacob17",
        email: "richard.jacob@leannon.com",
      },
      {
        id: "18",
        age: 21,
        name: "Shad Jast18",
        email: "pfeffer.matt@yahoo.com",
      },
      {
        id: "19",
        age: 45,
        name: "Duane Metz19",
        email: "mohammad.ferry@yahoo.com",
      },
      { id: "20", age: 34, name: "Myah Kris", email: "evolkman@hotmail.com" },
      {
        id: "21",
        age: 19,
        name: "Dr. Kamron Wunsch20",
        email: "lenora95@leannon.com",
      },
      {
        id: "22",
        age: 29,
        name: "David Pella21",
        email: "lenora95@leannon.com",
      },
      {
        id: "23",
        age: 27,
        name: "Richard Jacob22",
        email: "richard.jacob@leannon.com",
      },
      {
        id: "24",
        age: 21,
        name: "Shad Jast23",
        email: "pfeffer.matt@yahoo.com",
      },
      {
        id: "25",
        age: 45,
        name: "Duane Metz24",
        email: "mohammad.ferry@yahoo.com",
      },
      { id: "3", age: 34, name: "Myah Kris", email: "evolkman@hotmail.com" },
      {
        id: "26",
        age: 19,
        name: "Dr. Kamron Wunsch25",
        email: "lenora95@leannon.com",
      },
      {
        id: "27",
        age: 29,
        name: "David Pella26",
        email: "lenora95@leannon.com",
      },
      {
        id: "28",
        age: 27,
        name: "Richard Jacob27",
        email: "richard.jacob@leannon.com",
      },
       {
        id: "29",
        age: 27,
        name: "Richard Jacob28",
        email: "richard.jacob@leannon.com",
      },
       {
        id: "30",
        age: 27,
        name: "Richard Jacob29",
        email: "richard.jacob@leannon.com",
      },
       {
        id: "31",
        age: 27,
        name: "Richard Jacob30",
        email: "richard.jacob@leannon.com",
      },
       {
        id: "32",
        age: 27,
        name: "Richard Jacob31",
        email: "richard.jacob@leannon.com",
      },
           
    ]
};

const getters={
    MessagePagination:(state)=>(from,to)=>state.messages.slice(from,to),
    allMessages:(state)=>state.messages
};

const actions={

     fetchMessages({commit}){
  
        getMessagesData({
            params: {
                  
            }
        })
        .then(response => {
        })
        .catch(error => {
        });

        // const response= await axios.get('https://jsonplaceholder.typicode.com/todos')
    }
};

const mutations={};


export default{
    state,
    getters,
    actions,
    mutations
}



